import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { formatPrice, productTitle } from '@/lib/format'

import {
  LastScannedEmpty,
  LastScannedIcon,
  LastScannedImage,
  LastScannedInfo,
  LastScannedLabel,
  LastScannedPrice,
  LastScannedQty,
  LastScannedTitle,
  LastScannedWrapper,
} from './LastScannedItem.styles'

const LastScannedItem = ({ product, currency }) => {
  const { t, i18n } = useTranslation()
  const qty = useSelector(state =>
    product ? state.checkout.cart.find(item => item.id === product.id)?.qty || 0 : 0
  )

  if (!product) {
    return (
      <LastScannedEmpty>
        <LastScannedLabel>{t('scanner.lastScanned')}</LastScannedLabel>
        <span>—</span>
      </LastScannedEmpty>
    )
  }

  const title = productTitle(product, i18n.language)

  return (
    <LastScannedWrapper
      as={motion.div}
      key={`${product.id}-${i18n.language}`}
      initial={{ opacity: 0.4, x: -6 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.15, ease: 'easeOut' }}
      data-testid="last-scanned"
    >
      {product.icon ? (
        <LastScannedIcon>{product.icon}</LastScannedIcon>
      ) : (
        <LastScannedImage>
          <img src={product.imageUrl} alt="" />
        </LastScannedImage>
      )}
      <LastScannedInfo>
        <LastScannedLabel>{t('scanner.lastScanned')}</LastScannedLabel>
        <LastScannedTitle title={title}>{title}</LastScannedTitle>
      </LastScannedInfo>
      <LastScannedPrice>
        {qty > 1 && <LastScannedQty>{qty}×</LastScannedQty>}
        {formatPrice(product.price, currency)}
      </LastScannedPrice>
    </LastScannedWrapper>
  )
}

export default LastScannedItem
